export enum OutputFormat {
  Pdf = 'Pdf',
  Docx = 'Docx',
  Pptx = 'Pptx',
  Xlsx = 'Xlsx'
}
